/**
 * DEPRECATED: Use @/config/env.ts directly.
 *
 * This file is a thin re-export for backward compatibility.
 * All new code should import from @/config/env.ts.
 */
import { getApiBaseUrl } from '@/config/env';

export const resolveApiBaseUrl = getApiBaseUrl;

export default resolveApiBaseUrl;
